var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrivateFolder = function SvgPrivateFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0652 6.3L10.6739 3H2.19565C1.2588 3 0.5 3.73837 0.5 4.65V32.7C0.5 34.5224 2.01846 36 3.8913 36H36.1087C37.9815 36 39.5 34.5224 39.5 32.7V9.6C39.5 7.77758 37.9815 6.3 36.1087 6.3H14.0652Z",
    fill: "url(#paint0_linear_5323_310290)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 11H0.5V4.6C0.5 3.716 1.2588 3 2.19565 3H10.6739L14.0652 6.2H36.1087C37.9815 6.2 39.5 7.6328 39.5 9.4V11Z",
    fill: "#DB6C32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 11H1.5C1.5 8.68256 1.5014 7.12035 1.50107 5.00073C1.50098 4.44829 1.94875 4 2.50119 4H10.5L14 7.25L35.9949 7.20511C37.3776 7.20229 38.5 8.3228 38.5 9.7055C38.5 10.3753 38.5 10.8808 38.5 11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 11H0.5V8.1C0.5 7.216 1.2588 6.5 2.19565 6.5H10.6739L14.0652 9.7H39.5C39.5 10.5 39.5 10.5 39.5 11Z",
    fill: "#DB6C32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.9998H16C14.8953 29.9998 14 29.1045 14 27.9998V22.6665C14 21.5618 14.8953 20.6665 16 20.6665H24C25.1047 20.6665 26 21.5618 26 22.6665V27.9998C26 29.1045 25.1047 29.9998 24 29.9998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 20.6665C17.3333 19.1938 18.5273 17.9998 20 17.9998C21.4727 17.9998 22.6667 19.1938 22.6667 20.6665H24C24 18.4572 22.2093 16.6665 20 16.6665C17.7907 16.6665 16 18.4572 16 20.6665H17.3333Z",
    fill: "#FFE4D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 24C19.2637 24 18.667 24.5967 18.667 25.3333C18.667 26.07 19.2637 26.6667 20.0003 26.6667C20.737 26.6667 21.3337 26.07 21.3337 25.3333C21.3337 24.5967 20.737 24 20.0003 24Z",
    fill: "#DB794B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5323_310290",
    x1: -14,
    y1: -3.5,
    x2: 40.4193,
    y2: -2.17198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8602C"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrivateFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "privateFolder.ad83ccc0433670b72941aa280b7dd321.svg";